import { HOUSTON_URL_TEMPLATE } from "../constants/config";
import { Environment, UrlTemplates } from "../typings";

const TEMPLATE_REPLACE_KEY = "%s";

export const getUrlTemplate = (
  environment: Environment,
  urlTemplates: UrlTemplates,
) => {
  const urlTemplate = (urlTemplates ?? HOUSTON_URL_TEMPLATE)[environment];

  if (!urlTemplate) {
    throw new Error(
      `Could not get URL template with environment: '${environment}'`,
    );
  }

  return urlTemplate;
};

export const getHoustonDatafileUrl = ({
  environment,
  tenant,
  urlTemplates,
}: {
  tenant: string;
  environment: Environment;
  urlTemplates: UrlTemplates;
}) => {
  const template = getUrlTemplate(environment, urlTemplates);
  const encodedTenant = encodeURIComponent(tenant);

  return template.replace(TEMPLATE_REPLACE_KEY, `${encodedTenant}`);
};
